export default __webpack_public_path__ + "static/media/android.df7cb446.png";